import { Step } from "./Step";
import { StepTypes } from "../../enum/StepTypes";
import _ from 'lodash';

export class PayExemptionStep extends Step {
    private _payExemptions: any[];

    constructor(step: any, processConfigurationPayExemptions: any[]) {
        super(step);
        this._name = StepTypes.translations[step.type].name;
        this._payExemptions = processConfigurationPayExemptions.filter(processConfigurationPayExemption => step.payExemptions.includes(processConfigurationPayExemption.payExemptionType));
    }

    public get payExemptions() {
        return this._payExemptions;
    }

    public getPayExemptionsOrdered(currentLanguage: string) {
        
        return _.orderBy(this.payExemptions, [element => _.deburr(element.title[currentLanguage]).toLocaleLowerCase()]);
    }
}